import { useI18n } from 'domains/i18n/hooks'
import { useAppDispatch } from 'domains/store'
import { clearResumeConversationPrompt } from 'domains/store/slice'
import { actionTypes, dismissTypes } from 'ui/utils/seamly-utils'
import { useLiveRegion } from './live-region-hooks'
import { useSeamlyStateContext } from './seamly-state-hooks'
import useSeamlyCommands from './use-seamly-commands'

const useSeamlyResumeConversationPrompt = () => {
  const dispatch = useAppDispatch()
  const hasPrompt = useSeamlyStateContext().resumeConversationPrompt
  const { sendAction } = useSeamlyCommands()
  const { t } = useI18n()
  const { sendAssertive } = useLiveRegion()

  const continueChat = () => {
    sendAction({
      type: actionTypes.dismiss,
      body: { type: dismissTypes.resumeConversationPrompt },
    })
    dispatch(clearResumeConversationPrompt())
  }

  const restartChat = () => {
    sendAssertive(t('resumeConversationPrompt.srNotifyRestartText'))
    sendAction({ type: actionTypes.detachService })
    dispatch(clearResumeConversationPrompt())
  }

  return { continueChat, hasPrompt, restartChat }
}

export default useSeamlyResumeConversationPrompt
